var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.cardSelection,"item-text":"name","item-value":"number"},model:{value:(_vm.currentNumber),callback:function ($$v) {_vm.currentNumber=$$v},expression:"currentNumber"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }